export default function Simple({ value, text }) {
  if (!text || !value) return <p className="text-red-600">Not Available</p>;
  return (
    <a href={value} className="text-blue-600 hover:text-blue-900">
      {text}
    </a>
  );
}
